import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi';

import scrollTo from '../../utils/scrollTo';

import {
  Container,
  Logo,
  Navigator,
  MenuButton,
  SideMenuContainer,
} from './styles';

interface MenuItemProps {
  id: string;
  name: string;
  route: string;
}

interface HeaderProps {
  isReferable?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  isReferable = false,
}: HeaderProps) => {
  const [isMenuRef, setIsMenuRef] = useState(true);
  const [whiteBackground, setHeaderWhiteBackground] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    setIsMenuRef(isReferable);
  }, [isReferable]);

  useLayoutEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset <= 25) {
        setHeaderWhiteBackground(false);
      } else {
        setHeaderWhiteBackground(true);
      }
    };

    return () => {
      window.onscroll = null;
    };
  }, []);

  function scrollAndCloseMenu(id: string) {
    scrollTo(id);
    setOpenMenu(false);
  }

  const MenuItems: React.FC = () => {
    const MenuItem: React.FC<MenuItemProps> = ({
      id,
      name,
      route,
    }: MenuItemProps) => {
      if (isMenuRef) {
        return (
          <button type="button" onClick={() => scrollAndCloseMenu(id)}>
            {name}
          </button>
        );
      }

      return <Link to={route}>{name}</Link>;
    };

    return (
      <>
        <li>
          <MenuItem id="about-us" name="QUEM SOMOS" route="/sobre" />
        </li>
        <li>
          <MenuItem id="what-we-do" name="O QUE FAZEMOS" route="/nos" />
        </li>
        <li>
          <MenuItem id="portfolio" name="PORTFÓLIO" route="/portfolio" />
        </li>
      </>
    );
  };

  /*
    <li>
      <MenuItem id="contact" name="CONTATO" route="/contato" />
    </li>
  */

  return (
    <>
      <Container whiteBackground={whiteBackground}>
        <Link to="/">
          <Logo whiteBackground={whiteBackground}>
            <svg viewBox="0 0 52 74" xmlns="http://www.w3.org/2000/svg">
              <path d="M28.0803 17.424H29.0662V16.4381H28.0803V17.424ZM20.0981 11.9169H18.0377V13.9708H20.0981V11.9169ZM25.6399 4.52643H24.215V5.95137H25.6399V4.52643ZM28.6721 0H27.7581V0.914015H28.6721V0ZM45.1244 26.5989H42.6853V29.0379H45.1244V26.5989ZM35.1973 11.3135H34.4951V12.0144H35.1973V11.3135ZM31.7389 26.6643H29.1715V29.2318H31.7389V26.6643ZM36.7146 20.211H34.4514V22.4742H36.7146V20.211ZM10.3533 19.79H9.51115V20.6321H10.3533V19.79ZM39.5157 47.1039C39.2534 47.1036 38.9968 47.1812 38.7785 47.3268C38.5602 47.4724 38.3901 47.6795 38.2896 47.9219C38.189 48.1642 38.1627 48.431 38.2138 48.6883C38.2649 48.9457 38.3912 49.1821 38.5768 49.3676C38.7623 49.5532 38.9987 49.6795 39.2561 49.7306C39.5134 49.7817 39.7802 49.7554 40.0225 49.6549C40.2649 49.5543 40.472 49.3842 40.6176 49.1659C40.7632 48.9476 40.8408 48.691 40.8405 48.4287C40.8405 48.0773 40.701 47.7403 40.4525 47.4919C40.2041 47.2434 39.8671 47.1039 39.5157 47.1039ZM39.5337 35.3603H35.7685V34.8211H34.0856V34.3076H32.4026V35.3654H29.3794V33.2357H26.812V34.1035H24.7131V34.816H22.7875V32.5528H20.5705V34.4887H18.3573V35.3603H15.0658V34.2114H12.4984V35.3603L0 47.9922L25.9159 73.9094L52 47.8266L39.5337 35.3603ZM45.2861 49.3709L39.3809 55.2761L35.7236 58.9347C32.8159 58.0032 29.7899 57.4927 26.7375 57.4186C26.4636 57.4118 26.1898 57.4083 25.9159 57.4083C25.7015 57.4083 25.4872 57.4083 25.2741 57.4148C22.1624 57.4733 19.0759 57.9853 16.1121 58.9347L5.20039 48.023L6.61249 46.6109L6.76268 46.4607L7.28773 45.9357L12.1543 41.0793H40.0023L46.7932 47.8702L45.3156 49.3414V49.3273C45.3065 49.3423 45.2967 49.3569 45.2861 49.3709ZM36.9085 49.7432C36.6462 49.7429 36.3896 49.8205 36.1714 49.9661C35.9532 50.1116 35.783 50.3186 35.6824 50.5609C35.5819 50.8032 35.5554 51.0699 35.6064 51.3272C35.6575 51.5845 35.7837 51.8209 35.9691 52.0065C36.1545 52.1921 36.3908 52.3185 36.648 52.3698C36.9053 52.4211 37.172 52.3949 37.4144 52.2946C37.6568 52.1942 37.8639 52.0243 38.0097 51.8062C38.1555 51.5881 38.2333 51.3316 38.2333 51.0693C38.2333 50.7178 38.0938 50.3807 37.8453 50.1321C37.5969 49.8834 37.26 49.7435 36.9085 49.7432ZM34.2576 47.1039C33.9952 47.1036 33.7386 47.1812 33.5204 47.3268C33.3021 47.4724 33.1319 47.6795 33.0314 47.9219C32.9309 48.1642 32.9045 48.431 32.9556 48.6883C33.0068 48.9457 33.1331 49.1821 33.3186 49.3676C33.5042 49.5532 33.7406 49.6795 33.9979 49.7306C34.2553 49.7817 34.522 49.7554 34.7644 49.6549C35.0067 49.5543 35.2138 49.3842 35.3594 49.1659C35.5051 48.9476 35.5826 48.691 35.5824 48.4287C35.5824 48.0773 35.4428 47.7403 35.1944 47.4919C34.9459 47.2434 34.6089 47.1039 34.2576 47.1039ZM17.7424 47.1039H16.4587V46.0165C16.4584 45.9868 16.4554 45.9572 16.4497 45.928C16.4553 45.8785 16.4583 45.8288 16.4587 45.779C16.4642 45.6015 16.434 45.4247 16.3699 45.259C16.3058 45.0934 16.209 44.9423 16.0854 44.8148C15.9618 44.6873 15.8138 44.5859 15.6502 44.5166C15.4867 44.4474 15.3109 44.4117 15.1332 44.4117C14.9556 44.4117 14.7798 44.4474 14.6162 44.5166C14.4527 44.5859 14.3047 44.6873 14.1811 44.8148C14.0574 44.9423 13.9607 45.0934 13.8966 45.259C13.8325 45.4247 13.8023 45.6015 13.8078 45.779C13.8082 45.8288 13.8112 45.8785 13.8168 45.928C13.8117 45.9572 13.8087 45.9868 13.8078 46.0165V47.1039H12.4355C12.4188 47.1039 12.4034 47.1039 12.3867 47.1039C12.0524 47.1272 11.7395 47.2764 11.5109 47.5215C11.2824 47.7665 11.1553 48.0891 11.1553 48.4242C11.1553 48.7592 11.2824 49.0818 11.5109 49.3269C11.7395 49.5719 12.0524 49.7212 12.3867 49.7445C12.4034 49.7445 12.4188 49.7445 12.4355 49.7445H13.8091V51.0885C13.8084 51.0984 13.8084 51.1082 13.8091 51.1181C13.8241 51.4587 13.9699 51.7803 14.2163 52.0161C14.4626 52.2518 14.7904 52.3833 15.1313 52.3833C15.4722 52.3833 15.8 52.2518 16.0463 52.0161C16.2927 51.7803 16.4385 51.4587 16.4536 51.1181C16.4536 51.1078 16.4536 51.0988 16.4536 51.0885V49.7548H17.7373C17.9148 49.7603 18.0916 49.7301 18.2573 49.666C18.4229 49.6018 18.574 49.5051 18.7015 49.3815C18.8291 49.2578 18.9305 49.1099 18.9997 48.9463C19.0689 48.7827 19.1046 48.6069 19.1046 48.4293C19.1046 48.2517 19.0689 48.0759 18.9997 47.9123C18.9305 47.7488 18.8291 47.6008 18.7015 47.4771C18.574 47.3535 18.4229 47.2568 18.2573 47.1926C18.0916 47.1285 17.9148 47.0983 17.7373 47.1039H17.7424ZM19.2829 24.6668H20.8362V23.1135H19.2829V24.6668ZM36.9085 47.1039C37.1708 47.1039 37.4273 47.026 37.6454 46.8803C37.8635 46.7345 38.0334 46.5273 38.1338 46.2849C38.2341 46.0426 38.2603 45.7759 38.209 45.5186C38.1577 45.2613 38.0313 45.025 37.8457 44.8396C37.6601 44.6542 37.4237 44.528 37.1664 44.477C36.9091 44.426 36.6424 44.4524 36.4001 44.553C36.1578 44.6535 35.9508 44.8237 35.8053 45.042C35.6597 45.2602 35.5821 45.5167 35.5824 45.779C35.5824 45.9531 35.6167 46.1255 35.6834 46.2863C35.75 46.4471 35.8477 46.5932 35.9709 46.7163C36.094 46.8393 36.2402 46.9369 36.4011 47.0034C36.562 47.0699 36.7344 47.104 36.9085 47.1039Z" />
            </svg>
          </Logo>
        </Link>

        <Navigator whiteBackground={whiteBackground}>
          <MenuItems />
        </Navigator>

        <MenuButton
          type="button"
          onClick={() => setOpenMenu(true)}
          whiteBackground={whiteBackground}
        >
          <FiMenu />
        </MenuButton>
      </Container>

      <SideMenuContainer menuOpen={openMenu}>
        <MenuItems />
        <li>
          <button
            type="button"
            onClick={() => setOpenMenu(false)}
            style={{ color: '#000' }}
          >
            FECHAR
          </button>
        </li>
      </SideMenuContainer>
    </>
  );
};

export default Header;
